<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { fetchEventSettings } from '@/api/automations'
import { IAutomationFilters } from '@/interfaces/automations'

const FILTER_NAME = 'limit_type'

const props = defineProps<{ modelValue: IAutomationFilters }>()
const emit = defineEmits<{ 'update:modelValue': [IAutomationFilters] }>()

const loading = ref(false)
const options = ref<[string, string][]>([])

const limitTypes = computed({
  get: () => {
    const value = props.modelValue[FILTER_NAME]?.value
    return Array.isArray(value) ? value : []
  },
  set: (value: string[]) => {
    const { [FILTER_NAME]: _, ...filters } = props.modelValue
    emit(
      'update:modelValue',
      value.length
        ? { ...filters, [FILTER_NAME]: { predicate: 'included_in?', value } }
        : filters
    )
  }
})

const loadOptions = async () => {
  loading.value = true
  try {
    const response = await fetchEventSettings({
      event_type: 'CampaignLimitReached'
    })
    const filter = response.data.attributes.filter_options.find(
      (option) => option.name === FILTER_NAME
    )
    options.value = filter?.options.options_for_select || []
  } finally {
    loading.value = false
  }
}

onMounted(loadOptions)
</script>

<template>
  <el-form-item label="Limit types">
    <el-select
      v-model="limitTypes"
      :loading="loading"
      placeholder="All limit types"
      filterable
      clearable
      multiple
    >
      <el-option
        v-for="[label, value] in options"
        :key="value"
        :label="label"
        :value="value"
      />
    </el-select>
  </el-form-item>
</template>
